module.exports = __webpack_public_path__ + "static/media/qyj2_hg_20000_05.741aa7ea.png";